import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'underscore';
import { Button, makeStyles } from '@fluentui/react-components';
import { Stack } from '@fluentui/react';
import { AddRegular } from '@fluentui/react-icons';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useWizardService, WIZARD_EVENTS } from '@bingads-webui-react/wizard';
import { deleteAd } from '@bingads-webui-campaign-react/display-plus-native-ads';
import { StepHeader } from '../../../../shared/step-header';
import { AdThumbnail } from './ad-thumbnail';
import { STEP_PATHS, FLOWS, isAudienceAdGroupMultiAdCreation } from '../../../../step-constants';

const useFluentV2Styles = makeStyles({
  button: {
    display: 'flex',
    'flex-flow': 'column',
  },
  addIcon: {
    color: '#0078D4',
    fontSize: '52px',
  },
});

const getStyles = () => ({
  addNewAdButtonRoot: {
    height: 236,
    width: 212,
    borderRadius: '6px',
    border: '1px dashed #c8c6c4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const NativeAdsContainer = ({
  data,
  onDataChange,
  // error,
  // adMode,
}) => {
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext);
  const { state, send } = useWizardService();

  const { ads } = (data && data.ads) || {};

  const {
    flow, campaign, adGroup, ads: adsData,
  } = state.context.wizardData;

  const fluentV2Styles = useFluentV2Styles();

  const onClickCreateNewAd = () => {
    send(WIZARD_EVENTS.UPDATE_WIZARD_DATA, {
      editingAdId: null,
    });

    send(WIZARD_EVENTS.NAVIGATE_TO, {
      stepId: STEP_PATHS.MULTI_NATIVE_AD,
    });
  };

  const updateData = (adsToUpdate) => {
    onDataChange({
      data: {
        ...data,
        ads: {
          ...adsData,
          ads: {
            ...adsToUpdate,
          },
        },
      },
    });
  };

  const onDeleteAdClicked = (adId) => {
    deleteAd({
      ad: [ads[adId].data],
      campaign,
      adGroup,
    }).then(() => {
      const adsWithoutDeletedAd = _.omit(ads, adId);

      if (_.isEmpty(adsWithoutDeletedAd)) {
        updateData(adsWithoutDeletedAd);

        const updatedFlow = isAudienceAdGroupMultiAdCreation(flow) ? FLOWS.AUDIENCE_AD_GROUP_CREATION : FLOWS.AUDIENCE_CAMPAIGNS;

        send(WIZARD_EVENTS.UPDATE_WIZARD_DATA, {
          ads: {
            ...adsWithoutDeletedAd,
          },
          editingAdId: null,
          flow: updatedFlow,
        });

        send(WIZARD_EVENTS.SAVE_AND_GOTO, {
          stepId: STEP_PATHS.NATIVE_AD,
          flowFactors: { flow: updatedFlow },
        });
      } else {
        send(WIZARD_EVENTS.UPDATE_WIZARD_DATA, {
          ads: {
            ...adsData,
            ads: {
              ...adsWithoutDeletedAd,
            },
          },
        });
        updateData(adsWithoutDeletedAd);
      }
    });
  };

  const adIds = useMemo(() => _.keys(ads), [ads]);

  return (
    <div className="native-ads-container">
      <Stack tokens={{ childrenGap: 8 }}>
        <StepHeader
          title={_TL_('Ads')}
          description={_TL_('Create upto 15 ads for this campaign.')}
        />
      </Stack>
      <Stack horizontal tokens={{ childrenGap: 10 }} wrap>
        <div className={classNames([classes.addNewAdButtonRoot, 'create-another-ad'])}>
          <Button appearance="transparent" className={fluentV2Styles.button} onClick={onClickCreateNewAd}>
            <AddRegular className={fluentV2Styles.addIcon} />
            {i18n.getString(_TL_('Create new ad'))}
          </Button>
        </div>
        {
          data && adIds.map((adId, idx) => (
            <AdThumbnail key={adId} item={ads[adId].data} idx={idx} onDeleteAdClicked={onDeleteAdClicked} />
          ))
        }
      </Stack>
    </div>
  );
};

NativeAdsContainer.propTypes = {
  data: PropTypes.shape({}).isRequired,
  // onDataChange: PropTypes.func.isRequired,
  // error: PropTypes.shape({}).isRequired,
  // adMode: PropTypes.string.isRequired,
};
